import carrierZoneModule from "../carrierZoneModule"

carrierZoneModule.controller("carrierZoneSpeedController", ["$scope", "sourceEntity", "entity", "carrierZoneBaseController", ($scope, sourceEntity, entity, carrierZoneBaseController)=> {
    carrierZoneBaseController("carrier-zone-speed", $scope, sourceEntity, entity)
}])